import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Avatar } from "@zendeskgarden/react-avatars";

import styles from "./styles.css";

export default class Author extends PureComponent {
  static propTypes = {
    name: PropTypes.string.isRequired,
    email: PropTypes.string,
    avatar: PropTypes.string,
  };

  render() {
    const { name, avatar, email } = this.props;

    return (
      <div className={styles.container}>
        <Avatar>
          <img src={avatar} alt={`${name} ${email}`} />
        </Avatar>
        <span className={styles.label}>{name}</span>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Author/index.js